export function safeJoinNextPath(value: string | null | undefined): string | null {
  if (!value || typeof value !== 'string') return null;
  if (!value.startsWith('/join/')) return null;
  if (value.includes('//') || value.includes('\\') || value.includes('?') || value.includes('#')) {
    return null;
  }
  const token = value.slice('/join/'.length);
  if (!/^[A-Za-z0-9_-]{16,128}$/.test(token)) return null;
  return `/join/${token}`;
}

export function joinTokenFromNextPath(value: string | null | undefined): string | null {
  const path = safeJoinNextPath(value);
  return path ? path.slice('/join/'.length) : null;
}
